import {configureStore} from '@reduxjs/toolkit';
import {userReducer} from "./userReducer";
import {clientReducer} from "./clientReducer";
import criterionReducer from "./critereReducer";
import filesReducer from "./referentielReducer";
import {analyseReducer} from "./reviewReducer";
import {stageReducer} from "./stageReducer";
import {templateReducer} from "./templateReducer";
import {documentVersionReducer} from "./documentVersionReducer";
import {customMiddleware} from "./middleware/customMiddleware";
import uiReducer from "./uiReducer";
import aiTasksReducer from "./aiTasksReducer";
import { commercialControlReducer } from "./commercialControlReducer";

const store = configureStore({
    reducer: {
        // chat: chatReducer,
        users: userReducer,
        clients: clientReducer,
        criteria: criterionReducer,
        files:filesReducer,
        review:analyseReducer,
        stage:stageReducer,
        template:templateReducer,
        documentVersion:documentVersionReducer,
        ui: uiReducer,
        aiTasks: aiTasksReducer,
        commercialControl: commercialControlReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(customMiddleware),
});

export default store;
